module.exports = __webpack_public_path__ + "static/media/Circle-Plus_Blue.c9b635db.svg";